<fieldset
  [disabled]="isLoading$().show"
  [ngClass]="{ opacity: isLoading$().show, 'no-opacity': !isLoading$().show }"
>
  <div class="ai-hub-form mt-3">
    <div
      class="nav-item mb-2"
      (click)="isLoading$().show || navigateTo('home')"
      matTooltip="All posts"
    >
      <a href="javascript:void(0)">
        <img src="./assets/img/postgenie-2-doc.svg" />
      </a>
    </div>
    <div
      class="nav-item"
      (click)="isLoading$().show || navigateTo('profile')"
      matTooltip="My profile"
    >
      <a href="javascript:void(0)">
        <img src="./assets/img/postgenie-2-person.svg" />
      </a>
    </div>
  </div>
</fieldset>
